/// <amd-module name="Build/CDPipelinesTab/Constants" />

export namespace RunFilterKeys {
    export const StatusFilter = "statusFilter";
}
